import React, { useState, useContext, useEffect } from 'react';
import { Form } from 'react-bootstrap';
import { toast } from 'react-toastify';
import { UserContext } from '../../Context/UserContext';
import useForm from '../../useForm';
import { AuthUserApi, GuestApi } from '../../utils/api';
import validate from '../../validate/validateEscrow';
import { paymentFor } from '../../utils/constant';
import PaymentInformation from './PaymentInformation';
import { checkDataIsValid, getEncryptId } from '../../utils/secure';
import { useNavigate } from 'react-router-dom';
import moment from 'moment';
import EscrowDocForm from './EscrowDocForm';
import { useTranslation } from '../../Context/LanguageContext';

const TransacForm = (props) => {
  const { order } = props;
  const { t } = useTranslation();
  const [countries, setCountries] = useState([]);
  const [checked, setChecked] = useState(true);
  const [showInfo, setShowInfo] = useState(false);
  const [totalFee, setTotalFee] = useState(0);
  const [oppositeUser, setOppUser] = useState({});
  const [charge, setCharge] = useState([]);
  const [readOnly, setReadOnly] = useState(true);

  const navigate = useNavigate();

  const { user } = useContext(UserContext);

  const { email, role, name, country_id, wallet_address } = user?.user || {};

  const oppUser = role !== 'Buyer' ? 'Buyer' : 'Supplier';

  const formInputObj = {
    myRole: role,
    myName: name,
    myEmail: email,
    myCountry: country_id,
    paymentFor: 'Goods',
    startDate: moment().format('YYYY-MM-DD'),
    endDate: moment().format('YYYY-MM-DD'),
    userCountry: '',
    invoiceAmt: 0,
    additionalAmt: 0,
    userRole: oppUser,
    userEmail: '',
    userCompanyName: '',
    userContactName: '',
    description: '',
    address: '',
    myWAddress: '',
    userWAddress: '',
    fileUrl: '',
    escrowStatus: 'Pending',
    escrow_documents: [],
  };

  const handleChecked = (event) => {
    setChecked(event.target.checked);
  };

  const getData = async () => {
    try {
      const listResponse = await GuestApi.get(`/user/countries`);
      const { status, data } = listResponse;
      if (status === 200 && data.countries !== undefined) {
        setCountries(data.countries);
      }
    } catch (e) {
      console.log(`😱 Axios request failed: ${e}`);
    }
  };

  const getChargeData = async () => {
    try {
      const listResponse = await AuthUserApi.get(`/user/charge`);
      const { status, data } = listResponse;
      if (status === 200 && data.charge !== undefined) {
        setCharge(data.charge);
      }
    } catch (e) {
      console.log(`😱 Axios request failed: ${e}`);
    }
  };

  const handleValidation = () => {
    let errors = {};
    let formIsValid = true;

    if (!values.userCountry) {
      formIsValid = false;
      errors.userCountry = 'Country is required';
    }
    var validate = /^[0-9]*$/;
    if (!checkDataIsValid(values.invoiceAmt)) {
      formIsValid = false;
      errors.invoiceAmt = 'Invoice amount is required';
    } else if (!validate.test(values.invoiceAmt)) {
      formIsValid = false;
      errors.invoiceAmt = 'Amount should be number and greater than 0';
    }

    setErrors({ ...errors, errors });
    return formIsValid;
  };

  const handleEmailChange = async (event) => {
    const { name, value } = event.target;
    setValues({
      ...values,
      [name]: value,
    });
    try {
      if (/\S+@\S+\.\S+/.test(value)) {
        const listResponse = await AuthUserApi.post(`/user/get-opp-user`, {
          ...values,
          userEmail: value,
        });
        const { status, data } = listResponse;
        const { user, myUser } = data;
        if (status === 200 && user !== null) {
          setOppUser(user);
          if (user.country_id !== values.userCountry) {
            setErrors({
              ...errors,
              userCountry: `Selected country & ${oppUser} country doesn't match.`,
            });
          }
          setValues({
            ...values,
            userEmail: value,
            userContactName: user.name,
            userCompanyName: user.company_name,
            myWAddress:
              role == 'Buyer' ? myUser?.wallet_address : user?.wallet_address,
            userWAddress:
              role == 'Supplier'
                ? myUser?.wallet_address
                : user?.wallet_address,
          });
        } else {
          setValues({
            ...values,
            userEmail: value,
            userContactName: '',
            userCompanyName: '',
            myWAddress: '',
            userWAddress: '',
          });
        }
      }
    } catch (e) {
      console.log(`😱 Axios request failed: ${e}`);
    }
  };

  const submit = async () => {
    try {
      const formData = new FormData();
      for (let [key] of Object.entries(values)) {
        if (key === 'escrow_documents') {
          formData.append(key, JSON.stringify(values[key]));
        } else if (key === 'escrowStatus') {
          formData.append('escrowStatus', 'Pending');
        } else {
          formData.append(key, values[key]);
        }
      }
      if (values.escrow_documents && values.escrow_documents.length) {
        values.escrow_documents.forEach(function (escrowDoc, indx) {
          if (escrowDoc.documentName !== '' && escrowDoc.documentUrl !== '') {
            formData.append(`documentUrl${indx}`, escrowDoc.documentUrl);
          }
        });
      }
      let encId = getEncryptId(order.id);
      let saveResponse = null;
      if (Object.keys(order).length !== 0) {
        saveResponse = await AuthUserApi.put(
          `/user/transaction-update/${encId}`,
          formData,
        );
      } else {
        saveResponse = await AuthUserApi.post(
          '/user/transaction-create',
          formData,
        );
      }
      const { status, data } = saveResponse;
      if (status === 201 && data.escrow !== undefined) {
        setValues({ ...formInputObj });
        navigate(`/transaction-success/${data.escrow.id}`);
        toast.success(t('escrowCreated'));
      }
    } catch (e) {
      console.log(`😱 Axios request failed: ${e}`);
      const { response } = e;
      if (
        response !== undefined &&
        Object.keys(response.data).length &&
        response.data.error !== undefined
      ) {
        setErrors(response.data.error); // if error from server side
      }
    }
  };

  const sendLetter = async (e) => {
    try {
      const formData = new FormData();
      for (let [key] of Object.entries(values)) {
        if (key == 'escrowStatus') {
          formData.append('escrowStatus', 'In Draft');
        } else if (key === 'escrow_documents') {
          formData.append(key, JSON.stringify(values[key]));
        } else {
          formData.append(key, values[key]);
        }
      }
      if (values.escrow_documents && values.escrow_documents.length) {
        values.escrow_documents.forEach(function (escrowDoc, indx) {
          if (escrowDoc.documentName !== '' && escrowDoc.documentUrl !== '') {
            formData.append(`documentUrl${indx}`, escrowDoc.documentUrl);
          }
        });
      }
      e.preventDefault();
      if (handleValidation()) {
        let saveResponse = null;
        let encId = getEncryptId(order.id);
        if (Object.keys(order).length !== 0) {
          saveResponse = await AuthUserApi.put(
            `/user/transaction-update/${encId}`,
            formData,
          );
        } else {
          saveResponse = await AuthUserApi.post(
            '/user/transactiont-create',
            formData,
          );
        }
        const { status, data } = saveResponse;

        if (status === 201 && data.escrow !== undefined) {
          setValues({ ...formInputObj });
          navigate('/agreement-listing');
          toast.success(t('escrowCreated'));
        }
      }
    } catch (e) {
      console.log(`😱 Axios request failed: ${e}`);
      const { response } = e;
      if (
        response !== undefined &&
        Object.keys(response.data).length &&
        response.data.error !== undefined
      ) {
        setErrors(response.data.error); // if error from server side
      }
    }
  };

  const { handleChange, handleSubmit, values, errors, setErrors, setValues } =
    useForm(submit, validate, formInputObj);

  useEffect(() => {
    getData();
    getChargeData();
  }, []);

  useEffect(() => {
    var validNumber = new RegExp(/^\d*\.?\d*$/);
    if (
      checkDataIsValid(values.invoiceAmt) &&
      validNumber.test(values.invoiceAmt) &&
      parseFloat(values.invoiceAmt) != 0 &&
      charge?.charge !== undefined &&
      charge?.charge !== null
    ) {
      setShowInfo(true);
      let tax = parseFloat(charge.charge) || 0;
      let invAmt = parseFloat(values.invoiceAmt) || 0;
      let transFee = (invAmt * tax) / 100;
      setTotalFee(transFee + invAmt);
      setValues({ ...values, additionalAmt: transFee.toFixed(2) });
    } else {
      setShowInfo(false);
    }
  }, [values.invoiceAmt, charge]);

  useEffect(() => {
    if (Object.keys(order).length !== 0) {
      for (let [key] of Object.entries(formInputObj)) {
        if (key === 'escrow_documents') {
          formInputObj[key] = order.escrow_documents;
        } else {
          formInputObj[key] = order[key];
        }
      }
      setValues({ ...formInputObj });
    }
  }, [order]);

  return (
    <>
      <Form role='form'>
        <div className='card mb-4'>
          <div className='card-header pb-0 px-3'>
            <h6 className='mb-0'>1. {t('transactionSummary')}</h6>
          </div>
          <div className='card-body pt-4 p-3'>
            <div className='row'>
              <div className='col-12'>
                <label
                  htmlFor='exampleFormControlSelect1'
                  style={{ color: 'var(--text-primary)' }}
                >
                  {t('myRole')}
                </label>
                <div className='d-flex'>
                  <Form.Check
                    className='mb-1 pe-4'
                    style={{ color: 'var(--text-primary)' }}
                    type='radio'
                    label={t('buyer')}
                    value='Buyer'
                    name='myRole'
                    checked={values.myRole == 'Buyer'}
                  />
                  <Form.Check
                    className='mb-1'
                    style={{ color: 'var(--text-primary)' }}
                    type='radio'
                    label={t('supplier')}
                    value='Supplier'
                    name='myRole'
                    checked={values.myRole == 'Supplier'}
                  />
                </div>
              </div>
              <div className='col-12'>
                <div className='form-group'>
                  <label htmlFor='paymentFor' style={{ color: 'var(--text-primary)' }}>
                    {t('paymentFor')}
                  </label>
                  <select
                    className='form-control'
                    id='paymentFor'
                    name='paymentFor'
                    value={values.paymentFor}
                    onChange={handleChange}
                  >
                    {paymentFor &&
                      paymentFor.map((payment, i) => (
                        <option key={i} value={payment.value}>
                          {payment.label}
                        </option>
                      ))}
                  </select>
                </div>
              </div>
              <div className='col-12'>
                <div className='form-group'>
                  <label htmlFor='userCountry' style={{ color: 'var(--text-primary)' }}>
                    {oppUser === 'Buyer' ? t('buyer') : t('supplier')} {t('country')}
                  </label>
                  <select
                    className='form-control'
                    id='userCountry'
                    name='userCountry'
                    value={values.userCountry}
                    onChange={handleChange}
                  >
                    <option value=''>{t('selectCountry')}</option>
                    {countries &&
                      countries.length &&
                      countries.map((country) => (
                        <option value={country.id}>
                          {country.country_name}
                        </option>
                      ))}
                  </select>
                  {errors.userCountry && (
                    <small className='text-danger'>{errors.userCountry}</small>
                  )}
                </div>
              </div>
              <div className='col-12 col-md-6'>
                <div className='mb-3'>
                  <label htmlFor='StartDate' style={{ color: 'var(--text-primary)' }}>
                    {t('startDate')}
                  </label>
                  <input
                    type='date'
                    min={moment().format('YYYY-MM-DD')}
                    name='startDate'
                    onChange={handleChange}
                    value={moment(values.startDate).format('YYYY-MM-DD')}
                    className='form-control form-control-lg'
                  />
                  {errors.startDate && (
                    <small className='text-danger'>{errors.startDate}</small>
                  )}
                </div>
              </div>
              <div className='col-12 col-md-6'>
                <div className='mb-3'>
                  <label htmlFor='EndDate' style={{ color: 'var(--text-primary)' }}>
                    {t('endDate')}
                  </label>
                  <input
                    type='date'
                    min={
                      values.startDate
                        ? moment(values.startDate).format('YYYY-MM-DD')
                        : moment().format('YYYY-MM-DD')
                    }
                    name='endDate'
                    onChange={handleChange}
                    value={moment(values.endDate).format('YYYY-MM-DD')}
                    className='form-control form-control-lg'
                  />
                  {errors.endDate && (
                    <small className='text-danger'>{errors.endDate}</small>
                  )}
                </div>
              </div>
              <div className='col-12'>
                <label
                  htmlFor='exampleFormControlSelect1'
                  style={{ color: 'var(--text-primary)' }}
                >
                  {t('invoiceAmount')}
                </label>
                <div className='row'>
                  <div className='col-4 col-sm-4 col-md-3 pe-0'>
                    <p className='btn bg-gradient-dark btn-lg shadow-none w-100 mb-0 px-4 cursor-unset transform-none'>
                      USD
                    </p>
                  </div>
                  <div className='col-8 col-sm-8 col-md-9'>
                    <div className='mb-3'>
                      <input
                        type='text'
                        maxLength={10}
                        name='invoiceAmt'
                        value={values.invoiceAmt}
                        onChange={handleChange}
                        className='form-control form-control-lg'
                        placeholder={t('invoiceAmount')}
                        aria-label={t('invoiceAmount')}
                      />
                      {errors.invoiceAmt && (
                        <small className='text-danger'>
                          {errors.invoiceAmt}
                        </small>
                      )}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        {showInfo && <PaymentInformation values={values} totalFee={totalFee} />}
        {/* Transaction Details */}
        <div className='card mb-4'>
          <div className='card-header pb-0 px-3'>
            <h6 className='mb-0'>2. {t('transactionDetails')}</h6>
          </div>
          <div className='card-body pt-4 p-3'>
            <div className='row'>
              <div className='col-12'>
                <div className='row'>
                  <div className='col-4 col-sm-4 col-md-3'>
                    <label
                      htmlFor='exampleFormControlSelect1'
                      style={{ color: 'var(--text-primary)' }}
                    >
                      {t('myEmail')}
                    </label>
                  </div>
                  <div className='col-8 col-sm-8 col-md-9'>
                    <div className='mb-3'>
                      <p>{values.myEmail}</p>
                    </div>
                  </div>
                </div>
              </div>
              <div className='col-12 col-sm-12 col-md-6'>
                <div className='mb-3'>
                  <label htmlFor='ContactEmail' style={{ color: 'var(--text-primary)' }}>
                    {oppUser === 'Buyer' ? t('buyer') : t('supplier')}'s {t('contactEmail')}
                  </label>
                  <input
                    type='text'
                    name='userEmail'
                    onChange={handleEmailChange}
                    value={values.userEmail}
                    className='form-control form-control-lg'
                    placeholder={t('contactEmail')}
                    aria-label={t('contactEmail')}
                  />
                  {errors.userEmail && (
                    <small className='text-danger'>{errors.userEmail}</small>
                  )}
                </div>
              </div>
              <div className='col-12 col-sm-12 col-md-6'>
                <div className='mb-3'>
                  <label htmlFor='CompanyName' style={{ color: 'var(--text-primary)' }}>
                    {oppUser === 'Buyer' ? t('buyer') : t('supplier')}'s {t('companyName')}
                  </label>
                  <input
                    type='text'
                    readOnly={readOnly}
                    name='userCompanyName'
                    onChange={handleChange}
                    value={values.userCompanyName}
                    className='form-control form-control-lg'
                    placeholder={t('companyName')}
                    aria-label={t('companyName')}
                  />
                </div>
              </div>
              <div className='col-12 col-sm-12 col-md-6'>
                <div className='mb-3'>
                  <label htmlFor='ContactName' style={{ color: 'var(--text-primary)' }}>
                    {oppUser === 'Buyer' ? t('buyer') : t('supplier')}'s {t('contactDetails')}
                  </label>
                  <input
                    type='text'
                    readOnly={readOnly}
                    name='userContactName'
                    onChange={handleChange}
                    value={values.userContactName}
                    className='form-control form-control-lg'
                    placeholder={t('contactDetails')}
                    aria-label={t('contactDetails')}
                  />
                  {errors.userContactName && (
                    <small className='text-danger'>
                      {errors.userContactName}
                    </small>
                  )}
                </div>
              </div>
              <div className='col-12 col-sm-12 col-md-6'>
                <div className='mb-3'>
                  <label htmlFor='description' style={{ color: 'var(--text-primary)' }}>
                    {t('walletAddress')}
                  </label>
                  <input
                    type='text'
                    readOnly={readOnly}
                    name='userWAddress'
                    value={values.userWAddress}
                    className='form-control form-control-lg'
                    placeholder={t('walletAddress')}
                    aria-label={t('walletAddress')}
                  />
                </div>
              </div>
              <div className='col-12'>
                <div className='mb-3'>
                  <label htmlFor='description' style={{ color: 'var(--text-primary)' }}>
                    {t('descriptionOfDeal')}
                  </label>
                  <input
                    type='text'
                    name='description'
                    onChange={handleChange}
                    value={values.description}
                    className='form-control form-control-lg'
                    placeholder={t('description')}
                    aria-label={t('description')}
                  />
                  {errors.description && (
                    <small className='text-danger'>{errors.description}</small>
                  )}
                </div>
              </div>
              <div className='col-12'>
                <div className='mb-3'>
                  <label htmlFor='file' style={{ color: 'var(--text-primary)' }}>
                    {t('deliveryAddress')}
                  </label>
                  <input
                    type='text'
                    multiple
                    name='address'
                    className='form-control'
                    placeholder={t('address')}
                    aria-label={t('address')}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
        {/* Payment Release */}
        <div className='card mb-4'>
          <div className='card-header pb-0 px-3'>
            <h6 className='mb-0'>3. {t('paymentRelease')}</h6>
          </div>
          <div className='card-body pt-4 p-3'>
            <div className='row'>
              <div className='col-12'>
                <div className='row'>
                  <EscrowDocForm
                    handleSubmit={handleSubmit}
                    values={values}
                    setValues={setValues}
                    errors={errors}
                  />
                </div>
              </div>
              <div className='col-12'>
                  <p>
                  {t('paymentNotification')}
                </p>
              </div>
              <div className='col-12'>
                <div className='form-check form-check-info text-start'>
                  <input
                    className='form-check-input'
                    type='checkbox'
                    value=''
                    id='flexCheckDefault'
                    checked={checked}
                    onChange={handleChecked}
                  />
                  <label
                    className='form-check-label'
                    style={{ color: 'var(--text-primary)' }}
                    htmlFor='flexCheckDefault'
                  >
                    {t('iAgreeTerms')}{' '}
                    <a
                      href='javascript:;'
                      className='text-gold font-weight-bolder'
                    >
                      {t('termsAndConditions')}
                    </a>
                  </label>
                </div>
              </div>
              <div className='col-12 col-md-6'>
                <button
                  type='button'
                  onClick={(e) => sendLetter(e)}
                  className={`btn btn-outline-gold btn-lg px-3 w-100 mt-4 mb-0 ${checked ? '' : 'disabled'}`}
                >
                  {t('sendLater')}
                </button>
              </div>
              <div className='col-12 col-md-6'>
                <div className='text-center'>
                  <button
                    type='submit'
                    onClick={handleSubmit}
                    className={`btn btn-lg btn-gold btn-lg px-3 w-100 mt-4 mb-0 ${checked ? '' : 'disabled'}`}
                  >
                    {t('placeOrder')}
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </Form>
    </>
  );
};

export default TransacForm;
